export default __webpack_public_path__ + "static/media/Blog-assets-12.48a282ab.png";